import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const DashboardButton = ({ text, secondaryText, icon, selected, onClick, size = "default" }) => {
  const isSmall = size === "small";

  return (
    <Paper
      onClick={onClick}
      sx={{
        width: isSmall ? { xs: '100%', sm: 200 } : { xs: '100%', sm: 250 },
        height: isSmall ? 130 : 80,
        display: "flex",
        flexDirection: isSmall ? "column" : "row",
        justifyContent: "center",
        alignItems: "center",
        justifyContent: isSmall ? "center" : "flex-start",
        p: 2,
        gap: isSmall ? 1 : 2,
        cursor: "pointer",
        border: '1px solid',
        borderColor: selected ? "#1976d2" : 'divider',
        background: selected ? 'background.paper' : "transparent",
        "&:hover": { borderColor: "#1976d2" }
      }}
    >
      {icon}
      <Typography
          component="h2"
          variant="subtitle2"
          gutterBottom
          sx={{ fontWeight: '600', mb:0 }}
        >
          {text}
        </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary'}}>{secondaryText}</Typography>
    </Paper>
  );
};

export default DashboardButton;
